import React, { useEffect } from 'react';
import { connect, Provider } from 'react-redux';
import { Button, Modal } from 'antd';
import styled from 'styled-components'
import axios from 'axios';
import { hideModal } from '../store/actions';
import Footer from '../components/Footer';

const Logout = ({store, $location, $rootScope, hideModal}) => {

  useEffect(() => {
    $rootScope.$broadcast('closePreviewOverlay');
    $rootScope.$broadcast('logout');
  }, [$rootScope])

  useEffect(() => {
    hideModal();
    Modal.destroyAll();
    localStorage.removeItem('sessionId')
    axios.get('/api/authentication/logout');
  }, [hideModal])
  
  const goToLogin = () => {
    $location.url(`${decodeURIComponent(localStorage.getItem('loginPage'))}`);
    $rootScope.$apply();
  }

  return(
    <Provider store={store}>
      <LogoutContainer>
        <Header />
        <img alt="logo" src="/images/logo/large-logo-with-text.png" />
        <div className="logout-message">You have been logged out.</div>
        <Button size="large" onClick={goToLogin} style={{width: 250}}>Login</Button>
        <Footer />
      </LogoutContainer>
    </Provider>
  )
}

const LogoutContainer = styled.div`
  height: 100%;
  width: 100%;
  margin: auto;
  text-align: center;
  overflow-y: auto;
  background-color: var(--primary);
`

const Header = styled.div`
	height: 100px;
	background-color: var(--primary);
	color: #fff;
  box-sizing: border-box;
  z-index: 1;
  margin-right: 136px;
  user-select: none;
  -webkit-app-region:drag;
    i,
    .window-buttons,
    input[type="submit"],
    input[type="reset"],
    input[type="button"],
    input[type="text"],
    button,
    textarea {
      -webkit-app-region: no-drag;
    }
`

const mapStateToProps = state => {
  const { isAdmin } = state.user;
  return { isAdmin };
};

const mapDispatchToProps = { hideModal };

export default connect(mapStateToProps, mapDispatchToProps)(Logout);